<template>
    <div>
        <b-modal
            id="createStudent"
            title="Adicionar Aluno"
            hide-footer>
            <b-overlay :show="loading" rounded="sm">
                <b-form @submit="submit" @submit.stop.prevent >
                    <div id="createStudentFormTour">

                        <!-- Field -->
                        <b-form-group
                            v-if="matriculation"
                            label="Matrícula">
                            <!-- Input -->
                            <b-form-input
                                v-model="form.matriculation"
                                :state="hasErrors('matriculation', errors)"
                            ></b-form-input>
    
                            <!-- Error -->
                            <has-errors :errors="errors" name="matriculation" />
                        </b-form-group>
    
                        <!-- Field -->
                        <b-form-group
                            label="Nome">
                            <!-- Input -->
                            <b-form-input
                                v-model="form.name"
                                :state="hasErrors('name', errors)"
                            ></b-form-input>
    
                            <!-- Error -->
                            <has-errors :errors="errors" name="name" />
                        </b-form-group>
    
                        <!-- Field -->
                        <b-form-group
                            label="Email">
                            <!-- Input -->
                            <b-form-input
                                v-model="form.email"
                                :state="hasErrors('email', errors)"
                            ></b-form-input>
    
                            <!-- Error -->
                            <has-errors :errors="errors" name="email" />
                        </b-form-group>
    
                        <!-- Field -->
                        <b-form-group
                            label="Turma(s)"
                            description="Qual a(s) turma(s) que seu aluno irá participar ?">
    
                            <multiselect
                                v-model="form.groups"
                                :options="groupsOptions"
                                :taggable="true"
                                :multiple="true"
                                :loading="loading"
                                track-by="id"
                                label="name"
                                placeholder="Buscar por Turma(s) ..."
                                tag-placeholder="Escolher a Turma(s)"
                                selectLabel="Selecionar"
                                deselectLabel="Desmarcar"
                                selectedLabel="Selecionado">
    
                                <span slot="noResult">
                                    Ops! Nenhum resultado encontrado na pesquisa :(
                                </span>
    
                                <span slot="noOptions">
                                    Não há turmas disponíveis para exibir :(
                                </span>
    
                            </multiselect>
    
                            <!-- Error -->
                            <has-errors :errors="errors" name="groups" />
                        </b-form-group>
    
                        <!-- Field -->
                        <b-form-group
                            label="Senha Padrão" description="O aluno poderá trocar ela depois do primeiro acesso">
    
                            <!-- Input -->
                            <b-form-input
                                v-model="form.password"
                                :state="hasErrors('password', errors)"
                            ></b-form-input>
    
                            <!-- Error -->
                            <has-errors :errors="errors" name="password" />
                        </b-form-group>
    
                        <!-- Field -->
                        <b-form-group
                            v-if="credit"
                            label="Qtd. de Créditos">
    
                            <!-- Input -->
                            <b-form-input
                                type="number"
                                :min="0"
                                v-model="form.credit"
                                :state="hasErrors('credit', errors)"
                            ></b-form-input>
    
                            <!-- Error -->
                            <has-errors :errors="errors" name="credit" />
                        </b-form-group>
    
                        <!-- Field -->
                        <b-form-group
                            v-if="credit"
                            label="Data de Vencimento dos Créditos">
    
                            <!-- Input -->
                            <b-form-datepicker
                                v-model="form.due_date"
                                label-no-date-selected="Nenhuma data selecionada ..."
                                locale="pt-BR">
                            </b-form-datepicker>
    
                            <!-- Error -->
                            <has-errors :errors="errors" name="due_date" />
                        </b-form-group>
    
                        <!-- Field -->
                        <b-form-group
                            label="Observação"
                            description="Aqui você pode colocar uma observação do aluno para que os corretores possam saber previamente algum detalhe antes de corrigir.">
                            <!-- Input -->
                            <b-textarea
                                v-model="form.observation"
                                :state="hasErrors('observation', errors)"
                            ></b-textarea>
    
                            <!-- Error -->
                            <has-errors :errors="errors" name="observation" />
                        </b-form-group>
                    </div>

                    <!-- Submit -->
                    <b-button id="createStudentAddButtonTour" type="submit" variant="primary" :disable="loading">
                        Adicionar Aluno
                    </b-button>
                </b-form>
            </b-overlay>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: ['groupsOptions', 'matriculation', 'credit'],
    data() {
        return {
            loading: false,
            errors: {},
            form: {
                matriculation: null,
                name: null,
                email: null,
                groups: [],
                password: null,
                observation: null,
            }
        }
    },
    created() {
        this.$root.$on('createStudent', () => {
            this.$bvModal.show('createStudent')
        });
    },
    methods: {

        submit() {
            this.loading = true;
            axios.post('/teacher/students', {
                ...this.form,
                groups: this.form.groups.map(element => (element.id))
            })
                .then((result) => {

                    // Callback
                    this.$emit('created')

                    // Close Modal
                    this.$bvModal.hide('createStudent')

                    // Message
                    this.$toast.success('Aluno adicionado com sucesso !')

                    // Clear Form
                    this.form = {
                        matriculation: null,
                        name: null,
                        email: null,
                        groups: [],
                        password: null,
                        observation: null
                    }

                    // Clear Errors
                    this.errors = {}
                })
                .catch((errors) => {

                    // Check Errors
                    this.errors = this.setErrors(errors)

                })
                .finally(() => this.loading = false)
        },
    }
}
</script>

<style scoped>

</style>
